import { cn } from '@/lib/utils';

type BusinessCustomerItemProps = {
  customer: string;
  selected?: boolean;
  onSelect?: (customer: string) => void;
};

export function BusinessCustomerItem({ customer, selected, onSelect }: BusinessCustomerItemProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between bg-white p-2 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer',
        selected && 'bg-[#290BD9]/10',
      )}
      onClick={() => onSelect?.(customer)}
      role='button'
      tabIndex={0}
      aria-selected={selected}
    >
      <div className='flex items-center gap-3'>
        <span className='text-sm leading-[1.5rem]'>{customer}</span>
      </div>
    </div>
  );
}
